// Custom hook for handling template downloads
import { useCallback } from 'react';
import { useDownloadCloudTemplateMutation } from '../../../../api';

export const useTemplateDownload = (userOrg) => {
    const [downloadCloudTemplate, { isLoading: downloading }] = useDownloadCloudTemplateMutation();

    /**
     * Download cloud template
     */
    const downloadTemplate = useCallback(
        async (cloudType, templateOverride = null) => {
            if (!userOrg) {
                return { success: false, error: 'Organization ID is required' };
            }

            try {
                await downloadCloudTemplate({ cloudType, userOrg, templateOverride }).unwrap();
                return { success: true };
            } catch (error) {
                return { success: false, error: error.message || error.data?.message || 'Failed to download template' };
            }
        },
        [userOrg, downloadCloudTemplate],
    );

    return {
        downloading,
        downloadTemplate,
    };
};
